/**
 * An online-payment order whose payment was never completed (and that was not cancelled). Such an order is not shown
 * in "My Orders", but it can still be opened by its number (order page, Track Order) — it must not look confirmed.
 */
export const isUnpaidOnlineOrder = (order) =>
  String(order?.paymentMethod || '').toUpperCase() === 'PREPAID'
  && ['PENDING', 'FAILED'].includes(String(order?.financialStatus || '').toUpperCase())
  && String(order?.fulfillmentStatus || '').toUpperCase() !== 'CANCELLED';

export const UNPAID_LABEL = 'Payment not completed';
